import axios from 'axios';
import logService from '../services/logService';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api/v1';

const instance = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

// Add a request interceptor to add the auth token to every request
instance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('auth_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        logService.info(`Request: ${config.method.toUpperCase()} ${config.url}`, config.data || '');
        return config;
    },
    (error) => {
        logService.error('Request Error:', error);
        return Promise.reject(error);
    }
);

// Add a response interceptor to handle errors globally
instance.interceptors.response.use(
    (response) => {
        logService.info(`Response: ${response.status} ${response.config.url}`, response.data || '');
        return response;
    },
    (error) => {
        const status = error.response ? error.response.status : null;
        const message = error.response?.data?.message || error.message;

        logService.error(`API Error [${status}]: ${message}`, error.response?.data || error);

        if (status === 401) {
            // Unauthorized - could trigger logout or redirect
            logService.warn('Unauthorized access, clearing session...');
            localStorage.removeItem('auth_token');
            localStorage.removeItem('auth_user');

            // Only redirect if we're not already on the login page to avoid loops
            if (!window.location.pathname.includes('/login')) {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default instance;
